module.exports = __webpack_public_path__ + "static/cervical-826-common-safety-v4-715a5bc5f1d2bfb6c758ecb7ba39bf40.png";